<template>
    <b-modal v-model="show" :title="$t('auto.countryAdd')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Мамлакат номи <span class="red">*</span></label>
                        <v-select v-model="dictionaryData.data" label="nameRu"
                                  :options="countries"
                                  :filterable="false"
                                  @search="onCountrySearch"
                                  @search:focus="onCountryFocus"
                                  :class="{invalid: $v.dictionaryData.data.code.$error}"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                    </div>
                    <div class="form-group">
                        <label>Акциз қиймати <span class="red">*</span></label>
                        <numeric-input v-model="dictionaryData.data.rate" :precision="2"
                                       :class="{invalid : $v.dictionaryData.data.rate.$error}"></numeric-input>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>


<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: "ExciseTaxForCountryEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                show: false,
                processing: false,
                numericTypes: numericTypes,
                dictionaryData: {
                    id: null,
                    dictionaryType: 'EXCISE_TAX_FOR_COUNTRY',
                    data: {
                        code: null,
                        rate: null,
                        name: null,
                        nameRu: null
                    }
                },
                countries: [],
            }
        },
        validations: {
            dictionaryData: {
                data: {
                    rate: {
                        required
                    },
                    code: {
                        required
                    }
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('taxChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            onCountrySearch(searchTxt, loading) {
                loading(true);
                this.countries = [];
                this.filter.search = searchTxt;
                this.$http.post('country/search', this.filter)
                    .then(res => {
                        this.countries = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCountryFocus() {
                this.countries = [];
                this.filter.search = '';
                this.$http.post('country/search', this.filter)
                    .then(res => {
                        this.countries = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('ExciseTaxForCountryEditModal', (data) => {
                if (data) {
                    this.dictionaryData.id = data.id;
                    this.dictionaryData.data = clone(data.data);
                } else {
                    this.dictionaryData.id = null;
                    this.dictionaryData.data = {
                        code: null,
                        rate: null,
                        name: null,
                        nameRu: null
                    };
                }
                this.show = true;
            });
        }
    }
</script>
<style scoped>

</style>